import {gql} from "@apollo/client";

export const GET_ALL_JOB_RUNS = gql`
	query GetJobRuns(
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: JobRunFilterInput
		$order: [JobRunSortInput!]
	) {
		jobRun (
			before: $before
			after: $after
			first: $first
			last: $last
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				start
				finish
				description
				graphQlQuery
			   job {
					description
					jobDefinition {
						description
						jobSteps {
							id
							description
							order
						}
					}
				}
				jobStepRuns {
					jobStep {
						id
					}
					id
					total
					failed
					succeeded
					cancel
					start
					finish
				}
			}
		}
	}
`;
